import React, { useState, useEffect } from 'react';
import { Card, Typography, Space, Flex, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import PageLayout from '../../components/PageLayout';
import './PolicyPage.css';

const { Title } = Typography;

const PolicyPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [htmlContent, setHtmlContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const loadHtmlContent = async () => {
      setLoading(true);
      try {
        const lang = i18n.language || 'vi';
        const fileName = `policy-${lang}.html`;
        const response = await fetch(`/${fileName}`);
        
        if (response.ok) {
          const html = await response.text();
          setHtmlContent(html);
        } else {
          // Fallback to Vietnamese if language file not found
          const fallbackResponse = await fetch('/policy-vi.html');
          if (fallbackResponse.ok) {
            const html = await fallbackResponse.text();
            setHtmlContent(html);
          }
        }
      } catch (error) {
        console.error('Error loading policy HTML:', error);
      } finally {
        setLoading(false);
      }
    };

    loadHtmlContent();
  }, [i18n.language]);

  return (
    <PageLayout className="policy-page">
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Flex justify="center">
          <Title level={2} className="policy-title">
            {t('policy.title')}
          </Title>
        </Flex>

        <Card className="policy-card">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <Spin size="large" />
            </div>
          ) : (
            <div 
              className="policy-content-wrapper"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          )}
        </Card>
      </Space>
    </PageLayout>
  );
};

export default PolicyPage;

